// extracted by mini-css-extract-plugin
export default {"loader":"main_loader__mhx0T"};